import { Badge, IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const JustInfo = ({ title, ml = 0.5, mr = 1 }) => {
  return (
    <Tooltip title={title} arrow>
      <InfoOutlinedIcon
        className='no-export'
        sx={{
          color: "info.main",
          fontSize: 20,
          filter: "drop-shadow(0 2px 4px rgba(76, 175, 80, 0.3))",
          verticalAlign: "middle",
          ml: ml,
          mr: mr,
        }}
      />
    </Tooltip>
  );
};

export const StyledIconButton = ({
  onClick,
  tooltip,
  icon: Icon,
  iconSize = 18,
  iconColor = "primary.main",
  disabled = false,
  badgeContent = null,
  maxBadge = 99,
  sx = {
    p: 0.75,
    "&:hover": {
      backgroundColor: (theme) => {
        const colorMap = {
          "primary.main": "rgba(96, 63, 151, 0.15)",
          "secondary.main": "rgba(211, 29, 131, 0.15)",
          "error.main": "rgba(229, 57, 53, 0.15)",
          "warning.main": "rgba(237, 108, 2, 0.15)",
          "info.main": "rgba(2, 136, 209, 0.15)",
          "success.main": "rgba(46, 125, 50, 0.15)",
        };
        return colorMap[iconColor] || theme.palette.primary.light;
      },
      transform: "scale(1.05)",
      boxShadow: (theme) => {
        const shadowColorMap = {
          "primary.main": "rgba(96, 63, 151, 0.25)",
          "secondary.main": "rgba(211, 29, 131, 0.25)",
          "error.main": "rgba(229, 57, 53, 0.25)",
          "warning.main": "rgba(237, 108, 2, 0.25)",
          "info.main": "rgba(2, 136, 209, 0.25)",
          "success.main": "rgba(46, 125, 50, 0.25)",
        };
        return `0px 0px 6px 2px ${
          shadowColorMap[iconColor] || "rgba(96, 63, 151, 0.25)"
        }`;
      },
    },
    transition: "all 0.2s ease-in-out",
  },
}) => {
  const IconEl = Icon ? (
    <Icon
      sx={{
        fontSize: iconSize,
        color: disabled ? "#BDBDBD" : iconColor,
      }}
    />
  ) : (
    <InfoOutlinedIcon />
  );

  return (
    <Tooltip title={tooltip} placement='top'>
      <span style={{ display: "inline-block" }}>
        <IconButton
          color='primary'
          size='small'
          onClick={onClick}
          sx={sx}
          aria-label={tooltip}
          disabled={disabled}
        >
          {badgeContent ? (
            <Badge
              badgeContent={badgeContent}
              color='error'
              max={maxBadge}
              overlap='circular'
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                "& .MuiBadge-badge": {
                  right: 2,
                  top: 2,
                  fontSize: "0.65rem",
                  minWidth: "16px",
                  height: "16px",
                },
              }}
            >
              {IconEl}
            </Badge>
          ) : (
            IconEl
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};
